/**
 *  @class
 *  @function MegaMenuSidebar
 *
 *  Only the first (default) tab's content ships in the initial HTML - every other tab's
 *  product/collection grid used to render inline too, even though only one tab is visible
 *  at a time, bloating every page's HTML by 100KB+ for content almost no visitor opens.
 *  On first hover of any non-default tab, this fetches the real content once (all sidebar
 *  mega-menus on the page in one request) and fills in every pending placeholder.
 */
if (!customElements.get('mega-menu-sidebar')) {
  // Shared across every <mega-menu-sidebar> instance on the page - one fetch covers all of them.
  let lazyFetchPromise = null;
  function fetchLazyMegaMenuContent() {
    if (!lazyFetchPromise) {
      lazyFetchPromise = fetch('/products/gift-card?view=megamenu-fragment')
        .then(r => r.text())
        .then(text => new DOMParser().parseFromString(text, 'text/html'))
        .catch(() => null);
    }
    return lazyFetchPromise;
  }

  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });
      this.images = this.querySelectorAll('img');

      this._onLoad = () => {
        this.images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      };
      window.addEventListener('load', this._onLoad);
    }

    disconnectedCallback() {
      window.removeEventListener('load', this._onLoad);
    }

    fillPendingContent() {
      const pending = this.querySelectorAll('.mega-menu-sidebar--content-inner[data-lazy-pending]');
      if (!pending.length) return;
      const allSidebars = document.querySelectorAll('mega-menu-sidebar');
      const myIndex = Array.prototype.indexOf.call(allSidebars, this);
      fetchLazyMegaMenuContent().then(doc => {
        if (!doc) return;
        const matchingFragmentSidebar = doc.querySelectorAll('mega-menu-sidebar')[myIndex];
        if (!matchingFragmentSidebar) return;
        const fragmentPanels = matchingFragmentSidebar.querySelectorAll('.mega-menu-sidebar--content-inner');
        this.content.forEach((panel, i) => {
          if (panel.hasAttribute('data-lazy-pending') && fragmentPanels[i]) {
            panel.innerHTML = fragmentPanels[i].innerHTML;
            panel.removeAttribute('data-lazy-pending');
            panel.querySelectorAll('img').forEach(image => lazySizes.loader.unveil(image));
          }
        });
      });
    }

    onHover(event, button, i) {
      this.fillPendingContent();
      this.content.forEach((content, index) => {
        content.classList.remove('active');
        if (i == index) {
          content.classList.add('active');
        }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove('active');
      });
      button.classList.add('active');
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
